import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button, Dialog } from '@mui/material'
import { handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import CommunicationContext from '@/product/context/communication/communicationContext'
import SettingContext from '@/product/context/setting/settingContext'

import Loaders from '@/product/components/molecules/Loaders'

const Theme = (props) => {
    return (
        <>
            <Layout></Layout>
        </>
    )
}
export default Theme
